module.exports = __webpack_public_path__ + "img/header-como-jogar.2e618e5b.png";